import * as React from "react";
import { useContext, useEffect } from "react";
import { driver, DriveStep } from "driver.js";
import { Store } from "hooks/main_store";
import "./styles.css";
import { databaseService } from "utils/firebase";
import * as moment from "moment";
import LocalStorage from "utils/localStorage";
import { detectIncognito } from "utils/detectIncognito";

const TutorialDriver = () => {
  const { state } = useContext(Store);

  const renderTutorial = (steps: DriveStep[]) => {
    const driverObj = driver({
      popoverClass: "driverjs-theme",
      showProgress: true,
      // allowClose: false,
      smoothScroll: true,
      nextBtnText: "Siguiente →",
      prevBtnText: "← Volver",
      doneBtnText: "Cerrar",
      steps,
      onDestroyed: onFinish,
    });

    driverObj.drive();
  };

  const onFinish = React.useCallback(async () => {
    try {
      const result = await detectIncognito();

      if (state?.infoUser?.uid) {
        await databaseService.saveDatabase(
          `stepTutorial/${state.infoUser.uid}/${state.stepTutorial}`,
          { completed: moment().format("x") }
        );
      }
      LocalStorage(result.isPrivate).setItem(
        `stepTutorial_${state.stepTutorial}`,
        "completed"
      );
    } catch (error) {
      console.error(error);
    }
  }, [state.infoUser, state.stepTutorial]);

  const showProfileVideosTour = () => {
    renderTutorial([
      {
        popover: {
          title: "¡Reproduce y Gana con FROIN!",
          description:
            "Apoya contenido de artistas emergentes de nuestra comunidad, entre más consumas más puntaje haces.",
          side: "left",
          align: "start",
        },
      },
      {
        element: "#containerListPlayer",
        popover: {
          title: "Comienza a ganar aquí",
          description:
            "Selecciona algún contenido de la lista y te guiaremos en el proceso para que ganes.",
          side: "top",
          align: "center",
        },
      },
      {
        popover: {
          title: "Gana la competencia semanal",
          description:
            "Todo el puntaje que acumules por reproducir contenido es para subir tu posición en el ranking y ganar saldo en $FROIN",
        },
      },
      {
        element: "#menu-fab-button",
        popover: {
          title: "Conoce más",
          description:
            "Mientras vas navegando te guiaremos en el proceso para vivir la experiencia FROIN",
        },
      },
    ]);
  };

  const showRankingTour = () => {
    renderTutorial([
      {
        popover: {
          title: "Sigue de cerca tu progreso en el Ranking",
          description:
            "Aquí encontrarás toda la información del ranking de premios actual",
          side: "left",
          align: "start",
        },
      },
      {
        element: "#ranking-section-1",
        popover: {
          title: "Conoce tu posición actual",
          description:
            "Escala en la tabla de clasificación y gana aún mas $FROIN",
          side: "top",
          align: "center",
        },
      },
      {
        element: "#ranking-section-2",
        popover: {
          title: "Fecha límite",
          description:
            "Este es el tiempo que tienes para acumular puntaje y subir tu posición",
        },
      },
      {
        element: "#ranking-section-3",
        popover: {
          title: "Puntajes",
          description:
            "Revisa tu puntaje actual y el total que ha generado la comunidad (incluyendo el tuyo)",
        },
      },
      {
        element: "#ranking-section-4",
        popover: {
          title: "Bolsa de premios",
          description:
            "Esta es la cantidad de saldo en $FROIN que te correspondría del total a repartir, es proporcional a tu puntaje respecto al de la comunidad",
        },
      },
      {
        element: "#ranking-section-5",
        popover: {
          title: "Tabla de puntajes",
          description:
            "Te informamos tu posición y la de los demás usuarios de la comunidad",
        },
      },
      {
        element: "#ranking-section-6",
        popover: {
          title: "Revisa los TyC",
          description:
            "Estas son las reglas de juego para ser transparentes con nuestra comunidad",
        },
      },
    ]);
  };

  const showDetailVideoTour = () => {
    renderTutorial([
      {
        popover: {
          title: "Aquí comienza tu participación",
          description:
            "En este reproductor podrás consumir contenido de nuestros artistas y ganar puntaje para tu posición en el Ranking",
          side: "left",
          align: "start",
        },
      },
      {
        element: "#detail-video-info",
        popover: {
          title: "Conoce al artista",
          description:
            "Información relevante para que puedas conocer a quien estas apoyando",
          side: "top",
          align: "center",
        },
      },
      {
        element: "#detail-video-rewards",
        popover: {
          title: "OJO con las recompensas",
          description:
            "Cada contenido tiene un limite de puntaje que puedes hacer por día, revisa bien cuando llegues al tope y presiona en 'RECLAMAR' para sumar los puntos a tu Ranking",
        },
      },
      {
        element: "#detail-video-container-video",
        popover: {
          title: "Ahora a participar",
          description:
            "Este reproductor puede variar según la plataforma, NO TE SALGAS de esta página o sino no te contará el puntaje",
        },
      },
      {
        popover: {
          title: "Recuerda que aquí estamos",
          description:
            "Puedes contactarnos para cualquier solicitud que se te presente, por correo, WhatsApp o Instagram. ¡Suerte y a ganar!",
        },
      },
    ]);
  };

  const showRedeemTour = () => {
    renderTutorial([
      {
        popover: {
          title: "¡Es hora de redemir!",
          description:
            "Encuentra diferentes formas de redimir tu saldo de $FROIN y disfruta tus recompensas",
          side: "left",
          align: "start",
        },
      },
      {
        element: "#redeem-balance-section",
        popover: {
          title: "Valida tu saldo",
          description:
            "Esta es la cantidad de $FROIN disponible que puedes usar",
          side: "top",
          align: "center",
        },
      },
      {
        element: "#redeem-recommended-section",
        popover: {
          title: "Aún puedes acumular puntaje",
          description:
            "Te recomendamos el siguiente contenido para que subas tu posición en el Ranking",
        },
      },
      {
        element: "#redeem-coupons-section",
        popover: {
          title: "Escoge lo que quieras",
          description:
            "Aprovecha las ofertas de comercios que traemos para ti. RECUERDA que cada uno tiene sus correspondientes Términos y Condiciones.",
        },
      },
      {
        popover: {
          title: "OJO a tu correo",
          description:
            "En el momento que solicites tu recompensa tendremos un espacio de máximo 48 horas hábiles para darte respuesta del proveedor y enviarte tu recompensa.",
        },
      },
    ]);
  };

  const validateStep = React.useCallback(async () => {
    try {
      let isCompleted = false;
      const result = await detectIncognito();
      if (state?.infoUser?.uid) {
        const currentHistory = await databaseService.getDatabase(
          `stepTutorial/${state.infoUser.uid}/${state.stepTutorial}`
        );
        if (currentHistory.val()?.completed) {
          isCompleted = true;
        }
      }
      const localHistory = LocalStorage(result.isPrivate).getItem(
        `stepTutorial_${state.stepTutorial}`
      );
      if (isCompleted || localHistory === "completed") return;
      switch (state.stepTutorial) {
        case "menu-logged":
          break;
        case "profile-videos":
          showProfileVideosTour();
          break;
        case "ranking":
          showRankingTour();
          break;
        case "detail-video":
          showDetailVideoTour();
          break;
        case "redeem":
          showRedeemTour();
          break;
        default:
          break;
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.stepTutorial]);

  useEffect(() => {
    validateStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.stepTutorial]);

  return <></>;
};

export default TutorialDriver;
